<template>
  <div>
    <div class="position-relative" :style="level > 0 ? { paddingLeft: `${level * 15}px` } : {}">
      <CSidebarNavItem
        :title="gallery.name"
        :name="gallery.name"
        :class="[
            level === 0 ? 'blue-folder' : 'c-sidebar-nav-item__sub blue-folder', 
            {'has-sorter': canSort}, 
            {'is-last': isLast}
          ]"
        :to="{name: `eventWizard.gallery.${tab}`, params: {picaServiceId: picaServiceId, galleryId: gallery.id}}"
        :icon="gallery.is_public ? 'cipFolderBlueStar' : 'cipFolderBlue'"
      />
      <div class="d-flex folder-actions">
        <CIcon name="cipDot" :width="8" class="mr-2 text-danger" v-if="showMissingPriceListDot"/>
        <div :class="[level === 0 ? 'gallery-sort' : `gallery-sort-sub-${level}`, 'mr-1']" v-if="canSort">
          <CIcon size="lg" name="cipMenu01"/>
        </div>
      </div>
      <CLink class="link-p" :to="{name: `eventWizard.gallery.${tab}`, params: {picaServiceId: picaServiceId, galleryId: gallery.id}}">
        <div class="d-flex justify-content-between align-items-center missing-price-list"
             v-if="showMissingPriceListLabel">
          <div>
            <translate translate-context="event_wizard.label">Price list</translate>
          </div>
          <CIcon name="cipDotYellow" :width="10" class="pulse-icon"/>
        </div>
      </CLink>
    </div>

    <template v-if="gallery.sub && gallery.sub.length">
      <draggable v-model="gallery.sub" @end="updateSubGallerySorting" :handle="`.gallery-sort-sub-${level + 1}`"
                 ghost-class="ghost">
        <transition-group type="transition" :name="'flip-list'">
          <div v-for="(subGallery, index) in gallery.sub" :key="subGallery.id">
            <sub-gallery-nav
              :gallery="subGallery"
              :level="level + 1"
              :is-last="gallery.sub.length === index + 1"
              :can-sort="canSort && gallery.sub.length > 1"
              :tab="tab"
              :pica-service-id="picaServiceId"
              @update-sorting="handleSubSorting"
            />
          </div>
        </transition-group>
      </draggable>
    </template>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {mapGetters} from "vuex";

export default {
  name: 'SubGalleryNav',
  components: {
    draggable,
    SubGalleryNav: () => import('./SubGalleryNav.vue'),
  },
  props: {
    gallery: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean,
      default: false
    },
    canSort: {
      type: Boolean,
      default: false
    },
    tab: {
      type: String,
      required: true
    },
    picaServiceId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters('event', ['isSaas']),
    missingPriceList() {
      return this.gallery.missing_price_list && this.hasPerm('gallery.edit_some_price_list')
    },
    showMissingPriceListDot() {
      return !this.isSaas && this.missingPriceList
    },
    showMissingPriceListLabel() {
      return this.isSaas && this.missingPriceList
    }
  },
  methods: {
    updateSubGallerySorting() {
      this.$emit('update-sorting', {
        galleryId: this.gallery.id,
        ids: this.gallery.sub.map(sub => sub.id)
      })
    },
    handleSubSorting(data) {
      this.$emit('update-sorting', data)
    }
  }
}
</script>

<style scoped>
/* Ensure the indentation works well with existing styles */
.position-relative {
  transition: padding-left 0.2s ease;
}

.missing-price-list {
  margin-top: 14px;
  padding: 4px 10px 4px 30px;
  color: #4E4D64;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #CECCE8;
  }
}
.link-p {
  color: inherit;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
}

.pulse-icon {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.8);
  }
}
</style>
